module.exports = {"id":"222991","name":"Manabu Saito","rating":"71","photo":"./data/images/photos/0/222991.png","club":{"name":"Kawasaki Front.","logo":"./data/images/clubs/KawasakiFront..png"},"positions":["MG","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ManabuSaito0.json
// module id = 2671
// module chunks = 0